import { jsx as _jsx } from "react/jsx-runtime";
import { useDeviceState } from 'console/shared/contexts/device/state';
import { useLegacyHeatingModeState } from 'console/shared/hooks/device/legacy';
import { memo, useMemo } from 'react';
import { HeatingModeContent } from './types';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { selectDevice } from 'entities/device/lib';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
export const LegacyHeatingModeProvider = memo(function LegacyHeatingModeProvider(props) {
    const { config, children } = props;
    const { id } = config;
    const { online } = useDeviceState();
    const { device_id } = useDeviceConfig();
    const { thermostat_ext_mode, thermostat_target_temps } = useLegacyHeatingModeState();
    const manual_heating_circuits = useMemo(() => Object.values(thermostat_target_temps || {}).map(({ manual }) => manual), [thermostat_target_temps]);
    const is_some_heating_mode_in_mode = useMemo(() => manual_heating_circuits.some((manual) => !manual), [manual_heating_circuits]);
    const is_every_heating_mode_in_mode = useMemo(() => manual_heating_circuits.every((manual) => !manual), [manual_heating_circuits]);
    const active = useMemo(() => thermostat_ext_mode === id && is_some_heating_mode_in_mode, [thermostat_ext_mode, id, is_some_heating_mode_in_mode]);
    const disabled = useMemo(() => !online || is_every_heating_mode_in_mode, [online, is_every_heating_mode_in_mode]);
    const { fail, fail_message } = useAppSelector((state) => {
        const device = selectDevice(state, device_id);
        return {
            fail: device?.thermostat_ext_modes_config?.[id].fail,
            fail_message: device?.thermostat_ext_modes_config?.[id].fail_message,
        };
    });
    const heating_mode_state = useMemo(() => ({
        active,
        disabled,
        loading: false,
        fail: fail ?? false,
        fail_message: fail_message ?? '',
    }), [active, disabled, fail, fail_message]);
    const heating_mode = useMemo(() => ({
        ...heating_mode_state,
        ...config,
    }), [heating_mode_state, config]);
    return (_jsx(HeatingModeContent.Provider, { value: heating_mode, children: children }));
});
